module.exports = __webpack_public_path__ + "img/menu-message-white.2f35721f.svg";